import React from "react"
import { 
  Modal,
  Button,
  Table,
} from "react-bootstrap"
import { blockingFetchService } from "../../lib/blockingFetch"
import apiServerApi from "../../redux/sagas/apiServerApi"
import { fineractDateToStr } from "../../lib/utils"
import moment from "moment"

class DisplayTransactionModalScreen extends React.Component {

  state = {
    author: null,
    authorEmail: null,
    paymentTenure: null,
    externalId: null,
    externalDate: null,
    fromName: null,
    fee: 0,
    running: false,
    success: false,
    error: null,
  }

  componentDidMount() {
    const { transaction } = this.props
    if(this.isRepayment(transaction)) {
      this.getDetails(transaction)
    }
  }

  isRepayment = transaction => transaction && transaction.type.id === 2

  getDetails = transaction => {

    this.setState({
      running: true,
      success: false,
      error: null,
    })

    blockingFetchService(
      accessToken => apiServerApi.getTransactionByFineractId(accessToken, transaction.id), 
      repayment => {
        const { user, paymentTenure, externalId, externalDate, fromName, fee } = repayment
        this.setState({
          success: true,
          author: user ? user.name : '',
          authorEmail: user ? user.username : '',
          paymentTenure,
          externalId,
          externalDate,
          fromName,
          fee,
        })
      },
      error => { this.setState({ error: error.text }) },
      _ => { this.setState({ running: false }) }
    )
  }

  renderExternalInfo = currency => {

    const { externalId, externalDate, fromName, fee } = this.state
    if(!externalId) return null
    return (
      <p>
        <span>- <strong>External Id:</strong> { externalId }</span><br/>
        <span>- <strong>External date:</strong> { externalDate ? moment(externalDate).format('lll') : null }</span><br/>
        <span>- <strong>From:</strong> { fromName }</span><br/>
        <span>- <strong>Fee:</strong> { fee } { currency }</span>
      </p>
    )
  }

  render() {

    const { transaction, showTransaction, handleCloseTransation, updateOrDeleteAction } = this.props,

    { author, authorEmail, paymentTenure } = this.state

    return (
      <Modal show={ showTransaction } onHide={ handleCloseTransation } >

        <Modal.Header closeButton>
          <Modal.Title>Transaction details</Modal.Title>
        </Modal.Header>

        <Modal.Body>

          <Table responsive striped bordered condensed hover>

            <tbody>

              <tr>
                <td width="40%">ID</td>
                <td>{ transaction.id }</td>
              </tr>

              <tr>
                <td>Type</td>
                <td>{ transaction.type.value }</td>
              </tr>

              <tr>
                <td>Office name</td>
                <td>{ transaction.officeName }</td>
              </tr>

              <tr>
                <td>Date</td>
                <td>{ fineractDateToStr(transaction.date) }</td>
              </tr>

              <tr>
                <td>Currency</td>
                <td>{ transaction.currency.displayLabel }</td>
              </tr>

              <tr>
                <td>Amount</td>
                <td>{ transaction.amount }</td>
              </tr>

              <tr>
                <td>Net disbursal amount</td>
                <td>{ transaction.netDisbursalAmount }</td>
              </tr>

              <tr>
                <td>Outstanding loan balance</td>
                <td>{ transaction.outstandingLoanBalance }</td>
              </tr>

              <tr>
                <td>Submitted on date</td>
                <td>{ fineractDateToStr(transaction.submittedOnDate) }</td>
              </tr>

              <tr>
                <td>Manually reversed</td>
                <td>{ transaction.manuallyReversed ? 'True' : 'False' }</td>
              </tr>

              <tr>
                <td>Payment tenure</td>
                <td>{ paymentTenure }</td>
              </tr>

              <tr>
                <td>External information</td>
                <td>{ this.renderExternalInfo(transaction.currency.code) }</td>
              </tr>

              { this.isRepayment(transaction) &&
              <tr>
                <td>Saved by</td>
                <td>
                  { author }
                  { !!authorEmail && <small className="gray display-block">&#171; { authorEmail } &#187;</small>}
                </td>
              </tr>}
            </tbody>

          </Table>

        </Modal.Body>

        <Modal.Footer>

          <Button onClick={ handleCloseTransation }>Close</Button>

          { this.isRepayment(transaction) && !transaction.manuallyReversed &&
            <span>
              &nbsp;
              <Button onClick={() => updateOrDeleteAction(transaction.id, transaction.amount, transaction.date)}
                bsStyle="primary">Update</Button>
              <Button onClick={() => updateOrDeleteAction(transaction.id, 0, transaction.date)} 
                bsStyle="danger">Delete</Button>
            </span>
          }
        </Modal.Footer>

      </Modal>
    )
  }
}

export default DisplayTransactionModalScreen



// WEBPACK FOOTER //
// ./src/components/Loans/DisplayTransactionModal.js